<template lang="html">

  <section class="documents">
    <div class="pageHeading">
      <h1>{{pageTitle}}</h1>
    </div>


    <v-container grid-list-md text-xs-center>
      <v-layout v-if="openedDocument == null" row wrap>
        <v-flex xs12 md4 v-for="document in $structuredData.documents" >
            <v-card elevation="1">

                <v-card-title primary-title>
                    <v-flex md11 xs10 text-xs-left>
                        <h3 class="mb-0">{{document.name}}</h3>

                    </v-flex>

                    <v-flex md1 xs2 text-xs-right>

                        <v-icon v-if="document.signed != false"
                                large
                                color="green"
                        >
                            check
                        </v-icon>
                        <v-icon v-else
                                large
                                color="red"
                        >
                            error
                        </v-icon>
                    </v-flex>

                </v-card-title>


                <v-container style="border-top: lightgray 1px solid;
    cursor: pointer;"  >

                    <v-layout row wrap >
                        <v-flex  text-xs-center>
                            <span class="topTextBottomLabels">{{document.docType}}</span>
                            <br/>
                            <strong class="bottomLabels">Type</strong>

                        </v-flex>

                        <v-flex text-xs-center v-if="document.signed != false">
                            <span class="topTextBottomLabels">{{document.signed | moment("MM-DD-YYYY")}}</span>
                            <br/>
                            <strong class="bottomLabels">Signed</strong>
                        </v-flex>

                        <v-flex text-xs-center v-if="document.signed != false">
                            <v-btn class="mx-2" target="_blank" :href="document.file" dark small color="secondary">View Record</v-btn>
                        </v-flex>

                        <v-flex text-xs-center v-else>
                            <v-btn class="mx-2" @click="openedDocument = document"  dark small color="primary">Review & Sign</v-btn>
                        </v-flex>

                    </v-layout>

                </v-container>



            </v-card>
        </v-flex>
      </v-layout>

        <sign-document :formid="formID" v-else>

        </sign-document>

    </v-container>



  </section>

</template>

<script lang="js">
    import signDocument from '../components/SignDocument'
  export default  {
    name: 'documents',
    props: [],
      components: {
          signDocument: signDocument
      },
    mounted() {

    },
    data() {
      return {
          openedDocument: null
      }
    },
    methods: {

    },
    computed: {
        formID() {
            console.log('formID changed', this.openedDocument)
            if (this.openedDocument != null) {
                return this.openedDocument._id
            } else {
                return null
            }
        },
        pageTitle() {
            if (this.openedDocument == null) {
                return 'Documents'
            } else {
                return this.openedDocument.name
            }
        }

    }
}
</script>

<style scoped lang="scss">
  .documents {

      .bottomLabels {
          text-decoration: overline;
          font-size: 12px;
          position: relative;
          top: -3px;
      }

      .topTextBottomLabels {
          font-size: 15px;
      }

  }
</style>
